<script setup lang="ts">
import IconUser from '~icons/mdi/account-outline'
import IconChevronDown from '~icons/mdi/chevron-down'
import IconLogout from '~icons/mdi/sign-out'
import IconProfile from '~icons/mdi/account-circle'
import IconSettings from '~icons/mdi/settings'

const userStore = useUserStore()
const localePath = useLocalePath()
const { t } = useI18n()
const accountLabel = computed(() => userStore.data?.clinicShortName || t('layout.accountMenu.account'))
</script>

<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        data-test-id="menu-button"
        data-track-id="account_menu_open"
        variant="text"
        color="red-600"
        class="text-none px-1 px-xl-2 header-account-menu"
        :aria-label="accountLabel"
      >
        <v-icon
          :icon="IconUser"
          size="large"
          class="header-account-menu__icon mr-1 flex-shrink-0"
        />
        <span class="text-body-1 font-weight-bold text-truncate header-account-menu__label">
          {{ accountLabel }}
        </span>
        <v-icon
          :icon="IconChevronDown"
          size="20"
          class="ml-1 flex-shrink-0"
        />
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        :disabled="userStore.isUserDataPending"
        :prepend-icon="IconProfile"
        :title="$t('layout.accountMenu.profile')"
        :subtitle="userStore.data?.email"
        :to="localePath('/account/profile')"
        data-nav-id="account_profile"
      />
      <v-list-item
        :prepend-icon="IconSettings"
        :title="$t('customerReference.plural')"
        :to="localePath('/account/references')"
        data-nav-id="account_references"
      />

      <LangSwitcher inline />

      <LayoutVersionToggle />

      <v-divider />
      <v-list-item
        class="text-red"
        :title="$t('logout')"
        :prepend-icon="IconLogout"
        data-nav-id="account_logout"
        @click="userStore.logout()"
      />
    </v-list>
  </v-menu>
</template>

<style lang="scss">
.header-account-menu {
  max-width: 100%;
  min-width: 0 !important;

  .v-btn__content {
    min-width: 0;
  }

  &__label {
    flex: 1 1 0%;
    min-width: 0;
  }
}
</style>
